import React from "react";
import Button from "@mui/material/Button";
import classes from "./CategoryButton.module.css";

function CategoryButton(props) {
  return (
    <Button
      color="success"
      variant="contained"
      onClick={props.onClick}
      sx={{
        height: "400px",
        width: "400px",
        margin: "15px",
        pb: "20px",
        boxSizing: "border-box",
      }}
    >
      <div className={classes.buttonContent}>
        <div className={classes.buttonContentIcon}>{props.icon}</div>
        <div className={classes.buttonContentText}>{props.text}</div>
      </div>
    </Button>
  );
}

export default CategoryButton;
